import { useEffect, useState } from "react";
import { Menu, X, ShoppingBag } from "lucide-react";
import { BrandMark } from "./BrandMark";
import { scrollToHash } from "./scroll";

const GUACCI = "https://farmaciaguacci.it/brahma-golden-pb-50ml";

const LINKS = [
  { href: "#prodotti", label: "Prodotti", id: "nav-link-products" },
  { href: "#formulazione", label: "Formulazione", id: "nav-link-ingredients" },
  { href: "#cinema", label: "Cinema", id: "nav-link-cinema" },
  { href: "#contatti", label: "Contatti", id: "nav-link-contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (hash) => (e) => {
    setOpen(false);
    scrollToHash(hash)(e);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "glass shadow-[0_1px_0_rgba(197,160,89,0.28)]" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-10">
        <a href="#top" onClick={go("#top")} data-testid="nav-logo" className="flex items-center gap-3">
          <BrandMark className="h-8 w-8" />
          <span className="font-display text-xl tracking-[0.28em] text-ink">BRAHMA</span>
          <span className="hidden text-[10px] uppercase tracking-[0.3em] text-gold-deep sm:block">
            by Pómalab
          </span>
        </a>

        <div className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={go(l.href)}
              data-testid={l.id}
              className="text-[11px] uppercase tracking-[0.24em] text-smoke transition-colors duration-300 hover:text-gold-deep"
            >
              {l.label}
            </a>
          ))}
          <a
            href={GUACCI}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-cta-buy"
            className="flex items-center gap-2 rounded-full bg-gold-grad px-5 py-2.5 text-[11px] uppercase tracking-[0.2em] text-white shadow-[0_10px_24px_rgba(154,123,56,0.35)] transition-transform duration-300 hover:scale-[1.05]"
          >
            <ShoppingBag className="h-3.5 w-3.5" />
            Acquista
          </a>
        </div>

        <button
          className="rounded-full border border-gold/30 p-2 text-ink md:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open && (
        <div className="glass mx-4 mb-4 rounded-2xl border border-gold/25 p-5 md:hidden">
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={go(l.href)}
                data-testid={`${l.id}-mobile`}
                className="text-xs uppercase tracking-[0.24em] text-smoke"
              >
                {l.label}
              </a>
            ))}
            <a
              href={GUACCI}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-cta-buy-mobile"
              className="flex w-fit items-center gap-2 rounded-full bg-gold-grad px-5 py-2.5 text-[11px] uppercase tracking-[0.2em] text-white"
            >
              <ShoppingBag className="h-3.5 w-3.5" />
              Acquista
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
